import { render, staticRenderFns } from "./Massage.vue?vue&type=template&id=72234c35&scoped=true&"
import script from "./Massage.vue?vue&type=script&lang=js&"
export * from "./Massage.vue?vue&type=script&lang=js&"
import style0 from "./Massage.vue?vue&type=style&index=0&id=72234c35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72234c35",
  null
  
)

export default component.exports